import { isValidPhoneNumber } from 'libphonenumber-js';
import * as Yup from 'yup';

import { DENIED_EMAIL_CHARS_REGEX, EMAIL_FORMAT } from 'constants/Email';
import { LAST_6_DIGITS_SSN_MATCH_REGEX } from 'utils/curo-helpers/validation';

import { WelcomeFormFields, IWelcomeFormValues } from './constants';

export const applyFormValidationSchema = Yup.object<Yup.ObjectSchema<IWelcomeFormValues>>().shape({
  [WelcomeFormFields.BorrowerZipOrPostalCode]: Yup.string()
    .required('Zip code is required')
    .length(5, 'Invalid zip code length'),
  [WelcomeFormFields.BorrowerLast6DigitsSSN]: Yup.string()
    .required('SSN is required')
    .length(6, 'Invalid SSN')
    .matches(LAST_6_DIGITS_SSN_MATCH_REGEX, 'Invalid SSN'),
  [WelcomeFormFields.BorrowerEmail]: Yup.string()
    .trim()
    .required('Email is required')
    .email('Invalid email')
    .matches(EMAIL_FORMAT, 'Invalid email')
    .test(
      'isEmailMatches',
      'Please use email address without special characters',
      (value: string) => {
        const includeDeniedChars = value.match(DENIED_EMAIL_CHARS_REGEX);

        return !includeDeniedChars;
      },
    ),
  [WelcomeFormFields.BorrowerPhone]: Yup.string()
    .required('Phone is required')
    .test('isValidPhoneNumber', 'Invalid phone number', (value) => {
      if (!value) {
        return false;
      }
      return isValidPhoneNumber(value, {
        defaultCountry: 'US',
      });
    }),
  [WelcomeFormFields.TelephoneAndElectronicCommunicationPolicy]: Yup.boolean().notRequired(),
});
